import { apiConfig } from 'config';
import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';

export function getRoleList() {
  let url = apiConfig.authServiceGetRoleList;
  return fetchdata(url, { method: 'GET' }).catch((e) => {
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function getRoleUsers() {
  let url = apiConfig.authServiceGetRoleUsers;
  return fetchdata(url, { method: 'GET' }).catch((e) => {
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function roleAssign(user_id, roleids) {
  let body = {
    user_id,
    roleids
  };

  return fetchdata(apiConfig.authServiceRoleAssign, { method: 'POST', body: JSON.stringify(body) }).catch((e) => {
    console.log('assign roles error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function getAllPermissionList() {
  let url = apiConfig.authServiceGetAllPermissions;
  return fetchdata(url, { method: 'GET' }).catch((e) => {
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function createRole(roleName, roleDesc, rolePermissionsDict) {
  let body = {
    role: roleName,
    description: roleDesc,
    permissions: rolePermissionsDict
  };

  return fetchdata(apiConfig.authServiceRoleCreate, { method: 'POST', body: JSON.stringify(body) }).catch((e) => {
    console.log('assign roles error = ' + e.message);
    switch (e.message) {
      case '420':
        handle420();
        break;
      default:
        throw e;
    }
    return;
  });
}

export function updateRole(roleId, roleDesc, rolePermissionsDict) {
  let body = {
    description: roleDesc,
    permissions: rolePermissionsDict
  };

  return fetchdata(apiConfig.authServiceRoleUpdate(roleId), { method: 'PUT', body: JSON.stringify(body) }).catch(
    (e) => {
      console.log('assign roles error = ' + e.message);
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
      return;
    }
  );
}

export function deleteRole(roleId) {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
  };

  const url = apiConfig.authServiceRoleDelete(roleId);

  return fetch(url, { method: 'DELETE', headers: headers })
    .then((response) => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json();
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          console.log(e);
          throw Error('delete Role Failed');
      }
    });
}
